'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'user-filled',
    /* eslint-disable max-len */
    shape: _react2.default.createElement('path', { d: 'M12 13.3c2.7 0 8 1.5 8 4.5v2.3H4v-2.3C4 14.7 9.3 13.3 12 13.3L12 13.3zM12 12.8c-2.5 0-4.5-2-4.5-4.5 0-2.5 2-4.5 4.5-4.5 2.5 0 4.5 2.1 4.5 4.5C16.5 10.8 14.5 12.8 12 12.8z' }),
    /* eslint-enable max-len */
    viewbox: '0 0 24 24',
    label: 'User filled'
};
//# sourceMappingURL=user-filled.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/svg/user-filled.js
 ** module id = 292
 ** module chunks = 0
 **/